module.exports = __webpack_public_path__ + "img/chat.a987730e.svg";